var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2071 11.2929C29.5976 11.6834 29.5976 12.3166 29.2071 12.7071L22.8431 19.0711C22.4526 19.4616 21.8195 19.4616 21.4289 19.0711C21.0384 18.6805 21.0384 18.0474 21.4289 17.6569L27.0858 12L21.4289 6.34314C21.0384 5.95262 21.0384 5.31945 21.4289 4.92893C21.8195 4.53841 22.4526 4.53841 22.8431 4.92893L29.2071 11.2929ZM0.5 11L28.5 11L28.5 13L0.5 13L0.5 11Z",
    fill: "#FFFFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.107fdf90f4dd3e7dcd8f8f8b0626735d.svg";
export { ForwardRef as ReactComponent };